import { BrowserRouter, Switch, Route } from "react-router-dom";

import Marketplace from "./divulgacao/index";

export default function Routes() {
    return (
        <BrowserRouter>

            {/* TODO: Page Tracking GA */}

            <Switch>
                {/* <Route exact path="/" component={Home} /> */}

                {/*<PrivateRoute exact path="/" component={Marketplace} />*/}
                <Route exact path="/" component={Marketplace} />

            </Switch>

        </BrowserRouter>
    );
}
